import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BRAND_TYPE } from "@faire/help-center-utils/consts/BRAND_TYPE";
import { OTHER_TYPE } from "@faire/help-center-utils/consts/OTHER_TYPE";
import { RETAILER_TYPE } from "@faire/help-center-utils/consts/RETAILER_TYPE";
import { useLoggedOutContactUsContextStore } from "./LoggedOutContactUsContextStore";
export var useLoggedOutUserType = function useLoggedOutUserType() {
  var _useLoggedOutContactU = useLoggedOutContactUsContextStore(["user"]),
    _useLoggedOutContactU2 = _slicedToArray(_useLoggedOutContactU, 1),
    user = _useLoggedOutContactU2[0].user;
  var isRetailer = user === RETAILER_TYPE;
  var isKnownUserType = user === BRAND_TYPE || user === RETAILER_TYPE;
  var isUnknownUserType = user === OTHER_TYPE;
  return {
    user: user,
    isRetailer: isRetailer,
    isUnknownUserType: isUnknownUserType,
    isKnownUserType: isKnownUserType
  };
};